export default __webpack_public_path__ + "static/media/hornhippie_logo_primary.4fa07821.png";